import {MaybeType} from "../types";

/**
 * helper method to contruct wistia video embed url by id
 * @param {string} id
 * @return {string}
 */
export const constructWistiaVideoEmbedUrlById = (id: string) => {
  return `//fast.wistia.net/embed/iframe/${id}`;
};

/**
 * utility method to extract wistia thumbnail url
 * @param {string} object
 * @param {number?} width
 * @param {number?} height
 * @return {string}
 */
export const getWistiaThumbnailUrl = (
  source: any,
  width?: number,
  height?: number
): MaybeType<string> => {
  if (!source) {
    return null;
  }

  const rawSource = source.thumbnail.url.split("?")[0];

  if (width && height) {
    return `${rawSource}?image_crop_resized=${width}x${height}`;
  }

  return rawSource;
};

/**
 * helper method to grab wistia video details from contentful wistia json content
 * @param {string} jsonstr
 * @param {boolean} getFirstVideo
 * @return {Object | Array<Object>}
 */
export const parseContentfulWistiaVideoJSON = (
  jsonstr: MaybeType<string>,
  getFirstVideo: boolean = false
) => {
  if (!jsonstr) {
    return null;
  }

  const obj = JSON.parse(jsonstr);

  if (getFirstVideo) {
    const firstItem = obj.items[0];

    if (!firstItem) {
      return null;
    }

    // eslint-disable-next-line camelcase
    const {hashed_id, thumbnail} = firstItem;

    return {
      // eslint-disable-next-line camelcase
      hashed_id,
      thumbnail,
    };
  }

  return obj;
};
